/**
 * R7: onboarding routes are mode-specific — `/onboarding/{mode}/{segment}`.
 *
 * The backend onboarding step machine is unchanged; this maps a backend
 * step name to its frontend route. The `personal-setup` step maps to the
 * `setup` route segment — the `/personal/` prefix already conveys "personal",
 * so both modes share a `setup` segment.
 */

export type OnboardingFlowMode = 'business' | 'personal';

/** The mode-specific route segment for a backend onboarding step. */
export function onboardingStepSegment(step: string): string {
  return step === 'personal-setup' ? 'setup' : step;
}

/**
 * Build the mode-specific onboarding route for a step, optionally carrying
 * an OIDC `continue` param so suite-app handoff survives navigation.
 */
export function onboardingPath(
  mode: OnboardingFlowMode,
  step: string,
  continueUrl?: string,
): string {
  const path = `/onboarding/${mode}/${onboardingStepSegment(step)}`;
  return continueUrl ? `${path}?continue=${encodeURIComponent(continueUrl)}` : path;
}
